<template>
  <v-btn 
    class="app-bar__headline-button"
    fab
    depressed
    x-small
    @click="exportPdf"
    >
    <v-icon>mdi-file-pdf</v-icon>
  </v-btn>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { jsPDF } from "jspdf";
import 'jspdf-autotable';

export default {
  name: 'ExportComponent',

  computed: {
    ...mapState(['project', 'pageTitle', 'user', 'categories']),
    
    ...mapGetters(['exportProject', 'balance']),
  },

  methods: {
    getCategoryName(category) {
      let cat = this.categories.find((c) => c.id == category);
      let name = cat ? cat['name_'+this.$i18n.locale] : "";
      return name;
    },

    getSum(col) {
      let result = col.reduce((sum,val) =>  sum+val,0);
      return result;
    },

    exportPdf () {
      let dateStr = new Date().toLocaleString();
      dateStr = dateStr.split(',');
      dateStr = dateStr[0];

      let pdfName = 'NutriGap'+'_'+ this.project.name.replace(/\s/g, '')  + '_'+dateStr; 

      var doc = new jsPDF();
      
      doc.getFontList();   

      doc.setFontSize(13);
      doc.setFont('Jost', 'sans-serif');

      const startYPos = 25;
      const offset = 10;
      const tbOffset = 13;
      doc.setTextColor(47, 108, 134);
      doc.text(this.$i18n.t('pdfExport.project') + ': ' +this.project.name + ', ' + dateStr, 10, startYPos);

      doc.setFontSize(10);
      doc.setTextColor(107, 124, 133);

      
      let str_acreage = this.$i18n.t('plantProduction.acreage') + ' ' + this.project.acreage + ' ha.';
      doc.text(str_acreage, 10, startYPos + offset);

      if (!this.balance.acreage_sum) {
        doc.save(pdfName + '.pdf');
        return
      }
      
      str_acreage = this.$i18n.t('plantProduction.usedAcreage') + ' '+ this.balance.acreage_sum + ' ha.';
      doc.text(str_acreage, 10, startYPos + offset*2);

    let projectExport = this.exportProject;
      if (projectExport.plant_outputs.length === 0 && projectExport.animal_outputs.length === 0) {
        doc.save(pdfName + '.pdf');
        return;
      }
    
    let textPosition = startYPos + offset*3;
    if (projectExport.plant_outputs.length > 0) {
      doc.setFontSize(12);
      doc.setTextColor(47, 108, 134);
      
      doc.text(this.$i18n.t('projectView.plantProduction'), 15, textPosition);
      
      let str = this.$i18n.t('plantProduction.dataTable.name');
      var headPlants = [[str, this.$i18n.t('plantProduction.dataTable.acreage'), this.$i18n.t('plantProduction.dataTable.acreagePct'), this.$i18n.t('plantProduction.dataTable.yieldTHaY')]];
        doc.autoTable({
          styles: {
              cellPadding: 1.5,
              fontSize: 9
            },
          columnStyles: { 0: { halign: 'left'}, 1: { halign: 'right'}, 2: { halign: 'right'}, 3: { halign: 'right'}},
          head: headPlants,
          didParseCell: function (table) {
              if (table.section === 'head') {
                if (table.cell.raw === str) {
                  table.cell.styles.halign = 'left';
                } else {
                  table.cell.styles.halign = 'right';
                }
              }
            },
          body: projectExport.plant_outputs,
          margin: {top: 60},
          startY: 45+tbOffset,
        }
        );
    }

    if (projectExport.animal_outputs.length > 0) {
      finalY = doc.previousAutoTable.finalY;
      let strAnimalTableHeader = this.$i18n.t('animalProduction.dataTable.animal');
      var headAnimals = [[strAnimalTableHeader, this.$i18n.t('animalProduction.dataTable.amount'), this.$i18n.t('animalProduction.dataTable.unit')]];
      doc.setFontSize(12);
      doc.setTextColor(47, 108, 134);
      let animalProductionPos = projectExport.plant_outputs.length > 0 ? finalY + 10 : textPosition;
      doc.text(this.$i18n.t('projectView.animalProduction'), 15, animalProductionPos);
      

      let tablePos = projectExport.plant_outputs.length > 0 ? finalY + tbOffset : 45+tbOffset;
      doc.autoTable({
          styles: {
              cellPadding: 1.5,
              fontSize: 9
            },
          columnStyles: { 0: { halign: 'left'}, 1: { halign: 'right'}, 2: { halign: 'right'}},  
          head: headAnimals,
          didParseCell: function (table) {
              if (table.section === 'head') {
                if (table.cell.raw ===strAnimalTableHeader) {
                  table.cell.styles.halign = 'left';
                } else {
                  table.cell.styles.halign = 'right';
                }
              }
            },
          body: projectExport.animal_outputs,
          margin: {top: 60},
          startY: tablePos,
      });
    }

      doc.addPage();
      doc.setFontSize(12);
      doc.setFont('Jost', 'sans-serif');
      doc.setTextColor(47, 108, 134);
      doc.text(this.$i18n.t('projectView.balance'), 15, 25);

      let balanceExport = [
              [
                this.$i18n.t('balanceOverview.sumDemand'),
                '',
                (this.balance['N'].nutrient_demand * 0.001).toFixed(2),
                (this.balance['N'].nutrient_demand_per_ha).toFixed(2),
                '',
                (this.balance['P'].nutrient_demand * 0.001).toFixed(2),
                (this.balance['P'].nutrient_demand_per_ha).toFixed(2),
                '',
                (this.balance['K'].nutrient_demand * 0.001).toFixed(2),
                (this.balance['K'].nutrient_demand_per_ha).toFixed(2),
              ],
              [
                this.$i18n.t('balanceOverview.sumNutrients'),
                '',
                (this.balance['N'].demand_fulfillment_overview * 0.001).toFixed(2),
                (this.balance['N'].demand_fulfillment_per_ha_overview).toFixed(2),
                '',
                (this.balance['P'].demand_fulfillment_overview * 0.001).toFixed(2),
                (this.balance['P'].demand_fulfillment_per_ha_overview).toFixed(2),
                '',
                (this.balance['K'].demand_fulfillment_overview * 0.001).toFixed(2),
                (this.balance['K'].demand_fulfillment_per_ha_overview).toFixed(2),           
              ], 

              [
                this.$i18n.t('demandFulfillmentOverview.rowBalance'),
                (this.balance['N'].surplus_pct).toFixed(1),
                (this.balance['N'].surplus * 0.001).toFixed(2),
                (this.balance['N'].surplus_per_ha).toFixed(2),
                (this.balance['P'].surplus_pct).toFixed(1),
                (this.balance['P'].surplus * 0.001).toFixed(2),
                (this.balance['P'].surplus_per_ha).toFixed(2),
                (this.balance['K'].surplus_pct).toFixed(1),
                (this.balance['K'].surplus * 0.001).toFixed(2),
                (this.balance['K'].surplus_per_ha).toFixed(2),         
              ]
            ];

      var headSaldo = [['', 'N (%)', 'N (t)', 'N (kg/ha)', 'P (%)', 'P (t)', 'P (kg/ha)', 'K (%)','K (t)', 'K (kg/ha)']];
      doc.autoTable({
          styles: {
            cellPadding: 1.5,
            fontSize: 9
          },
          columnStyles: { 0: { halign: 'left'}, 1: { halign: 'right'}, 2: { halign: 'right'}, 3: { halign: 'right'}, 4: { halign: 'right'}, 5: { halign: 'right'}, 6: { halign: 'right'}, 7: { halign: 'right'}, 8: { halign: 'right'}, 9: { halign: 'right'}},
          head: headSaldo,
          didParseCell: function (table) {
            if (table.section === 'head') {
              if (table.cell.raw === strDemandsHeader) {
                table.cell.styles.halign = 'left';
              } else {
                table.cell.styles.halign = 'right';
              }
            }
          },
          body: balanceExport,
          margin: {top: 60},
          startY: 15+tbOffset,
        });

      let finalY = doc.previousAutoTable.finalY;
      doc.setFontSize(12);
      doc.setFont('Jost', 'sans-serif');
      doc.setTextColor(47, 108, 134);
      //doc.text(this.$i18n.t('pdfExport.interimBalanceTitle'), 15,  startYPos + offset);

      let titles = [this.$i18n.t('plantProduction.detailsView.demand'), this.$i18n.t('pdfExport.fertilizerHeader'), this.$i18n.t('pdfExport.bioFixHeader')];
  
      var headSaldoReduced = [['Name', 'N (t)', 'N (kg/ha)','P (t)', 'P (kg/ha)','K (t)', 'K (kg/ha)']];
      var headSaldoBio = [['Name', 'N (t)', 'N (kg/ha)','', '','', '']];
  
      var headSaldoLosses = [['Name', '%', 'N (t)', 'N (kg/ha)','', '','', '']];
      
      for (var balanceGroupIdx = 0; balanceGroupIdx < 3; balanceGroupIdx++) {
        
        finalY = doc.previousAutoTable.finalY;

        doc.setFontSize(11);
        if (!finalY) {
          doc.text(titles[balanceGroupIdx], 18, startYPos + offset*4);
        } else {
          let finalY = doc.previousAutoTable.finalY;
          doc.text(titles[balanceGroupIdx], 18, finalY + 10);
        }

        let rows = [];
        let itemsPerBalanceGroup = this.balance.groups[balanceGroupIdx];

        itemsPerBalanceGroup.forEach(item => {
            rows.push([
               this.getCategoryName(item.name),
                item.Nkg ? (item.Nkg / 1000).toFixed(1) : '',
                item.N ? (item.N).toFixed(1) : '',
                item.Pkg ? (item.Pkg / 1000).toFixed(1) : '',
                item.P ? (item.P).toFixed(1) : '',
                item.Kkg ? (item.Kkg / 1000).toFixed(1) : '',
                item.K ? (item.K).toFixed(1) : ''
            ]);
 
        });
        if (balanceGroupIdx === 0) {
          rows.push([
                'Total',
                (this.balance['N'].nutrient_demand /1000).toFixed(1),
                (this.balance['N'].nutrient_demand_per_ha).toFixed(1),
                (this.balance['P'].nutrient_demand/1000).toFixed(1),
                (this.balance['P'].nutrient_demand_per_ha).toFixed(1),
                (this.balance['K'].nutrient_demand/1000).toFixed(1),
                (this.balance['K'].nutrient_demand_per_ha).toFixed(1) 
          ]);
        }

        if (balanceGroupIdx === 1) {
          rows.push([
                'Total',
                (this.balance['N'].fertilizer_prod /1000).toFixed(1),
                (this.balance['N'].fertilizer_prod_per_ha).toFixed(1),
                (this.balance['P'].fertilizer_prod/1000).toFixed(1),
                (this.balance['P'].fertilizer_prod_per_ha).toFixed(1),
                (this.balance['K'].fertilizer_prod/1000).toFixed(1),
                (this.balance['K'].fertilizer_prod_per_ha).toFixed(1) 
          ]);
        }

         if (balanceGroupIdx === 2) {
          rows.push([
                'Total',
                (this.balance['N'].bnf / 1000).toFixed(0),
                (this.balance['N'].bnf_per_ha).toFixed(0),
                '',
                '',
                '',
                ''
          ]);
        }
        
        let pos = 0; 
        if (balanceGroupIdx == 0) {
          pos = (doc.previousAutoTable.finalY ? doc.previousAutoTable.finalY : startYPos + offset*3) + tbOffset;
        } else {
          pos = (doc.previousAutoTable.finalY ? doc.previousAutoTable.finalY : 23) + tbOffset;
        }

        doc.autoTable({
          styles: {
            cellPadding: 1.5,
            fontSize: 9
          },
          columnStyles: { 0: { halign: 'left'}, 1: { halign: 'right'}, 2: { halign: 'right'}, 3: { halign: 'right'}, 4: { halign: 'right'}, 5: { halign: 'right'}, 6: { halign: 'right'}},
          head: balanceGroupIdx < 2 ? headSaldoReduced: headSaldoBio,
          didParseCell: function (table) {
            if (table.section === 'head') {
              if (table.cell.raw ==='Name') {
                table.cell.styles.halign = 'left';
              } else {
                table.cell.styles.halign = 'right';
              }
            }
          },
          body: rows,
          margin: {top: 60},
          startY: pos,
        });
        
      }

      let titlesRest = [this.$i18n.t('nutrientBalance.deposition'), this.$i18n.t('nutrientBalance.fertilizerLoss')];
      finalY = doc.previousAutoTable.finalY;
      doc.text(titlesRest[0], 18, (finalY ? finalY : 0) + 10);

      rows = [
        ['Deposition', String(this.balance['N'].deposition) , String(this.project.deposition)
        ]
      ];
      var headSaldoDeposition = [['Name', 'N (t)', 'N (kg/ha)','', '','', '']];
      let pos = (doc.previousAutoTable.finalY ? doc.previousAutoTable.finalY : 0) + tbOffset;
      doc.autoTable({
         styles: {
            cellPadding: 1.5,
            fontSize: 9
          },
          columnStyles: { 0: { halign: 'left'}, 1: { halign: 'right'}, 2: { halign: 'right'}, 3: { halign: 'right'}, 5: { halign: 'right'}},
          
          head: headSaldoDeposition,
          didParseCell: function (table) {
            if (table.section === 'head') {
              if (table.cell.raw ==='Name') {
                table.cell.styles.halign = 'left';
              } else {
                table.cell.styles.halign = 'right';
              }
            }
          },
          body: rows,
          margin: {top: 60},
          startY: pos,
        });

      finalY = doc.previousAutoTable.finalY;

      doc.text(titlesRest[1], 18, (finalY ? finalY : 0) + 10);
      pos = (doc.previousAutoTable.finalY ? doc.previousAutoTable.finalY : 0) + tbOffset;
      let rows = [];

      rows.push([
          this.$i18n.t('nutrientBalance.stallLoss'),
          Number(this.project.lossesStorage) ? (this.project.lossesStorage) : 0,
          ((this.balance['N'].losses_storage)*0.001).toFixed(1),
          (this.balance['N'].losses_storage_per_ha).toFixed(0)
      ]);

      rows.push([
          this.$i18n.t('nutrientBalance.outputLoss'),
          Number(this.project.lossesOutput) ? (this.project.lossesOutput) : 0 ,
          ((this.balance['N'].losses_output)*0.001).toFixed(1),
          (this.balance['N'].losses_output_per_ha).toFixed(0)
      ]);

      rows.push([
          'Total',
          Number(this.balance['N'].losses_pct) ? (this.balance['N'].losses_pct).toFixed(1) : 0,
          Number((this.balance['N'].losses)*0.001) ? ((this.balance['N'].losses)*0.001).toFixed(1) : 0,
          Number(this.balance['N'].losses_per_ha) ? (this.balance['N'].losses_per_ha).toFixed(0) : 0
      ]);

        doc.autoTable({
          styles: {
            cellPadding: 1.5,
            fontSize: 9
          },
          columnStyles: { 0: { halign: 'left'}, 1: { halign: 'right'}, 2: { halign: 'right'}, 3: { halign: 'right'}},
          head: headSaldoLosses,
          didParseCell: function (table) {
            if (table.section === 'head') {
              if (table.cell.raw ==='Name') {
                table.cell.styles.halign = 'left';
              } else {
                table.cell.styles.halign = 'right';
              }
            }
          },
          body: rows,
          margin: {top: 60},
          startY: pos,
        });

    
    
     
    if (projectExport.fertilizer.length === 0) {
      doc.save(pdfName + '.pdf');
      return;
    }

     doc.addPage();
     doc.setFontSize(12);
     doc.setTextColor(47, 108, 134);
     doc.text(this.$i18n.t('pdfExport.demandFulfillments'), 15, 25);

     let strDemandsHeader = this.$i18n.t('demandFulfillment.dataTable.culture');
     var headFertilizer = [[strDemandsHeader, this.$i18n.t('demandFulfillment.dataTable.amount'), 'N (t)', 'N (kg/ha)','P (t)', 'P (kg/ha)','K (t)', 'K (kg/ha)']];
     
      for (var key = 0; key < projectExport.fertilizer.length; key ++) {
        let demandFulfillment = projectExport.fertilizer[key];
        let demandFulfillmentName = projectExport.demandFulfillmentNames[key];
        let scenario = projectExport.scenarios[key];
      
        if (key === 0) {
          doc.text(this.$i18n.t('pdfExport.scenario') + demandFulfillmentName, 15, startYPos+offset);
          pos = startYPos + tbOffset;
        } else {
          let finalY = doc.previousAutoTable.finalY;
          doc.text(this.$i18n.t('pdfExport.scenario') + demandFulfillmentName, 15, finalY + 10);
          pos = finalY + tbOffset;
        }

        doc.autoTable({
          styles: {
            cellPadding: 1.5,
            fontSize: 9
          },
          columnStyles: { 0: { halign: 'left'}, 1: { halign: 'right'}, 2: { halign: 'right'}, 3: { halign: 'right'}, 4: { halign: 'right'}, 5: { halign: 'right'}, 6: { halign: 'right'}, 7: { halign: 'right'}, 8: { halign: 'right'}, 9: { halign: 'right'}},
          head: headSaldo,
          didParseCell: function (table) {
            if (table.section === 'head') {
              if (table.cell.raw === strDemandsHeader) {
                table.cell.styles.halign = 'left';
              } else {
                table.cell.styles.halign = 'right';
              }
            }
          },
          body: scenario,
          margin: {top: 60},
          startY: pos,
        });

        finalY = doc.previousAutoTable.finalY;
        pos = finalY + tbOffset;

        doc.autoTable({
          styles: {
            cellPadding: 1.5,
            fontSize: 9
          },
          columnStyles: { 0: { halign: 'left'}, 1: { halign: 'right'}, 2: { halign: 'right'}, 3: { halign: 'right'}, 4: { halign: 'right'}, 5: { halign: 'right'}, 6: { halign: 'right'}, 7: { halign: 'right'}},
          head: headFertilizer,
          didParseCell: function (table) {
            if (table.section === 'head') {
              if (table.cell.raw === strDemandsHeader) {
                table.cell.styles.halign = 'left';
              } else {
                table.cell.styles.halign = 'right';
              }
            }
          },
          body: demandFulfillment,
          margin: {top: 60},
          startY: pos,
        }
      );
      }
      doc.save(pdfName + '.pdf');
    }
  }
}
</script>